import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedFilters } from "../models/Items/ItemListRequest";
import { SortDirection } from "../models/Enum";

export type ProductAssignmentsListRequest = SelectedFilters & {
    pageIndex: number;
    pageSize: number;
    sortBy: string;
    sortDirection: SortDirection;
};

type FiltersState = {
    selectedFilterOptions: any;
    selectedFilterValues: SelectedFilters;
  }

interface ProductAssignmentsState {
    productAssignmentsListRequest: ProductAssignmentsListRequest
    productAssignmentsListView: FiltersState
};

export const initialProductAssignmentsListRequest = {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "updatedDate",
    sortDirection: SortDirection.DESC,
};

const initialState: ProductAssignmentsState = {
  productAssignmentsListRequest: initialProductAssignmentsListRequest,
  productAssignmentsListView: {
    selectedFilterOptions: {},
    selectedFilterValues: {},
  },
};

const productAssignments = createSlice({
  name: 'productAssignments',
  initialState,
  reducers: {
    updateProductAssignmentsListRequest(state, action: PayloadAction<ProductAssignmentsListRequest>) {
      state.productAssignmentsListRequest = action.payload;
    },
    updateProductAssignmentsViewSelectedFilterOptions(state, action: PayloadAction<any>) {
      state.productAssignmentsListView.selectedFilterOptions = action.payload;
    },
    updateProductAssignmentsViewSelectedFilterValues(state, action: PayloadAction<SelectedFilters>) {
      state.productAssignmentsListView.selectedFilterValues = action.payload;
    },
  },
});

export const { updateProductAssignmentsListRequest, updateProductAssignmentsViewSelectedFilterOptions, updateProductAssignmentsViewSelectedFilterValues } = productAssignments.actions;

export default productAssignments.reducer;
